import { isApiError } from 'api';
import { formatNumber } from 'ui';

import type { NetTakeError, TransportPriceEstimateError } from '../../types';

const getTransportPriceErrorMessage = (transportPriceError: TransportPriceEstimateError) => {
  if (!transportPriceError) {
    return;
  }
  if (!transportPriceError?.response) {
    return 'Error calculating transport price';
  }
  if (isApiError(transportPriceError.response.data)) {
    return `${transportPriceError.response.data.detail.split('. ')[0]}`;
  }
  return 'Error calculating transport price';
};

const getOfferPriceErrorMessage = (priceError?: string) => {
  if (!priceError) {
    return;
  }
  return `Price: ${priceError?.split('. ')[0]}`;
};

const getNetTakeRateErrorMessage = (netTakeRateError?: NetTakeError) => {
  if (!netTakeRateError) {
    return;
  }
  if (!netTakeRateError?.response) {
    return 'NTR: Error calculating NTR';
  }
  if (isApiError(netTakeRateError.response.data)) {
    return `NTR: ${netTakeRateError.response.data.detail.split('. ')[0]}`;
  }
  return 'NTR: Error calculating NTR';
};

const indexPercentageMessage = (percent: number) => {
  const formattedPercent = formatNumber(percent, {
    minimumFractionDigits: 0,
    style: 'percent',
  });
  return `${formattedPercent} of LME`;
};

export const assembleHelperPriceText = (priceError: string | undefined, price: number | null) => {
  const offerPriceErrorMessage = getOfferPriceErrorMessage(priceError);
  const errors = [offerPriceErrorMessage].filter(Boolean).join('; ');
  const indexPricePercentageMessage = price ? indexPercentageMessage(price) : '';
  return errors || indexPricePercentageMessage;
};

export const assemblerHelperTransportPriceText = (transportPriceError: TransportPriceEstimateError) => {
  return getTransportPriceErrorMessage(transportPriceError);
};
